import type { VoucherAllocationRow } from "@/hooks/use-project-detail";

/**
 * VIB-997 (tidl. VIB-545): summer bilag-kost per budsjettlinje for
 * "x bilag · y kr"-indikatoren i budsjett-tabben.
 *
 * Grupperer på allocation.budget_line_id (null hoppes over), summerer amount
 * og teller. Tar KUN med allokeringer som tilhører et `approved` bilag
 * (voucher_status). NB: `count` er nå antall allokeringer, ikke antall bilag —
 * det matcher den nye fordelings-modellen der ett bilag kan treffe flere linjer.
 */
export function groupAllocationsByBudgetLine(
  allocations: VoucherAllocationRow[],
): Map<string, { amount: number; count: number }> {
  const map = new Map<string, { amount: number; count: number }>();
  for (const a of allocations) {
    if (!a.budget_line_id || a.voucher_status !== "approved") continue;
    const cur = map.get(a.budget_line_id) ?? { amount: 0, count: 0 };
    cur.amount += Number(a.amount ?? 0);
    cur.count++;
    map.set(a.budget_line_id, cur);
  }
  return map;
}
